import { Link as RouterLink } from "react-router-dom";
import { Box, Heading, HStack, Stack, Text, useMediaQuery } from "@chakra-ui/react";

import { RoutesMap } from "../../../../routes.tsx";

export function MainPageOperationHistory() {
  const [isSmallScreen] = useMediaQuery("(max-width: 340px)");

  return (
    <Box
      as={RouterLink}
      to={RoutesMap.operations}
      h={isSmallScreen ? "unset" : "84px"}
      w="100%"
      pt="20px"
      pb="16px"
      px="16px"
      bg="white"
      borderRadius="16px"
      cursor="pointer"
    >
      <HStack w="100%" ml="4px" justifyContent="space-between" alignItems="flex-start">
        <Stack spacing={0}>
          <Heading mb="5px">
            История операций
          </Heading>
          <Text fontSize="14px">Переводы, покупки, платежи</Text>
        </Stack>
      </HStack>
    </Box>
  );
}
